import { useTranslation } from 'react-i18next';
import utilities from '@/core/utilities';
import { successToast } from '@/utilities/toast.utilities';
import { Button } from '@seeqdev/qomponents';

export const CopyBranchCode = ({ text, branchCode }: { text: string; branchCode: string }) => {
  const { t } = useTranslation();

  const copyBranchCodeToClipboard = async (code: string) => {
    if (!code) return;

    await utilities.copyTextToClipboard(code);
    successToast({
      messageKey: 'HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_SUCCESS',
      messageParams: { branchCode: code },
    });
  };

  return (
    <div className="flexColumnContainer flexAlignCenter gap4 minWidthZero">
      <span className="flexNoShrink">{t(text)}</span>
      <span className="branchCodeHighlighting overflowHidden textOverflowEllipsis nowrap flexNoGrow minWidthZero">
        {branchCode}
      </span>
      <Button
        tooltip={t('HOME_SCREEN.TRAINING.COPY_BRANCH_CODE_TOOLTIP')}
        icon="fa-copy"
        iconStyle="text"
        variant="no-border"
        extraClassNames="sq-light-gray"
        testId="copyBranchCodeButton"
        onClick={() => copyBranchCodeToClipboard(branchCode)}
      />
    </div>
  );
};
